import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { getHomeUserSpecificData } from '@/Redux/Ducks/homeSlice';
import { getNotification } from '@/Redux/Ducks/inboxSlice';
import { ArrayKeyValueObject, KeyValueObject } from '@/UI/Interfaces/IBaseUI';
import BaseMethods from 'AlignBaseUI/BaseMethods';
import { useEffect, useState } from 'react';
import { HiUserGroup } from 'react-icons/hi';
// @ts-ignore
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';

const NodeComponent = ({ node }: any) => (
  <div className="node">
    <div className="node-item">
      <img src={BaseMethods.getUserPhoto(node.employeeimage)} alt="Profile" />
      <div className="node-text">
        <h6>{node.employeestxt}</h6>
        <span>{node.positionstxt}</span>
      </div>
    </div>
  </div>
);

const Ornanogram = () => {
  const dispatch = useAppDispatch();

  const dataLoaded = useAppSelector(x => x.Home.dataLoaded);
  const orgData = useAppSelector(x => x.Home.orgData);

  const [structuredData, setStructuredData] = useState<any>(null);

  const transformToHierarchy = (data: ArrayKeyValueObject) => {
    const employeeMap = new Map();

    // Initialize the map
    data.forEach((employee: KeyValueObject) => {
      employeeMap.set(employee.employeeno, { ...employee, children: [] });
    });

    const roots: any[] = [];

    // Build hierarchy
    data.forEach((employee: KeyValueObject) => {
      const parent = employeeMap.get(employee.reportingto);
      const current = employeeMap.get(employee.employeeno);

      if (!employee.reportingto || employee.employeeno === employee.reportingto || !parent) {
        roots.push(current); // This is a root node
      } else {
        parent.children.push(current); // Attach to parent
      }
    });

    return roots;
  };

  useEffect(() => {
    if (!dataLoaded) {
      dispatch(getHomeUserSpecificData());
      // dispatch(getUserInsights());
      dispatch(getNotification({ key: "/approval/active", reload: true, searchParam: '' }));
    }
  }, [dataLoaded]);

  useEffect(() => {
    if (orgData.length >= 1)
      setStructuredData(transformToHierarchy(orgData));
  }, [orgData])

  return orgData.length >= 1 && structuredData ? (
    <div className="ornanogram">
      <div className="designer-bar">
        <HiUserGroup size={18} className="icon" />
        Ornanogram
      </div>
      <div className="ornanogram-container">
        {structuredData.map((tree: any, index: number) => (
          <OrgChart
            key={index}
            className="org-chart"
            tree={tree}
            NodeComponent={NodeComponent}
          />
        ))}
      </div>
    </div>
  ) : null;
}

export default Ornanogram